// import { SortableContainer } from 'react-sortable-hoc';

import React, { useState, useEffect, useImperativeHandle } from 'react';
import { Form } from 'antd';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {
  restrictToVerticalAxis,
  restrictToWindowEdges,
} from '@dnd-kit/modifiers';
import SortableItem from './formItem';
import { deleteMarkFromKeyName, headArrContent } from './formUtils';
import { connect } from 'react-redux';
import action from '@flux/action';
// import '@style/modules/analysis/keyExecutives.scss';
import '../../../../styles/modules/analysis/keyExecutives.scss';

const KeyExecutive = (props) => {
  const {
    type,
    cRef,
    keyExecutivesBoxStyles = {},
    executivesHeadStyles = {},
    bodyContentList,
    keyContactsData,
    saveKeyContactsData,
  } = props;
  const [form] = Form.useForm();
  const [isAnimation, setIsAnimation] = useState(false);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(KeyboardSensor),
  );

  useEffect(() => {
    bodyContentList && form.setFieldsValue(bodyContentList);
  }, [bodyContentList]);

  useImperativeHandle(cRef, () => ({ form }));

  const handleDragStart = () => {
    const obj = form.getFieldsValue();
    saveKeyContactsData({
      ...keyContactsData,
      buyer: deleteMarkFromKeyName(obj, '1'),
    });
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      // Convert string IDs back to numbers for finding indices
      const oldIndex = parseInt(active.id);
      const newIndex = parseInt(over.id);

      if (!isNaN(oldIndex) && !isNaN(newIndex)) {
        const obj = { ...bodyContentList };
        obj.executives1 = arrayMove(obj.executives1, oldIndex, newIndex);

        saveKeyContactsData({
          ...keyContactsData,
          buyer: deleteMarkFromKeyName(obj, '1'),
        });
      }
    }
  };

  return (
    <div className="key-executives-box" style={keyExecutivesBoxStyles}>
      <Form
        form={form}
        name="executivesForm"
        autoComplete="off"
        defaultValue={bodyContentList}
      >
        <div className="executives-head" style={executivesHeadStyles}>
          {Array.isArray(headArrContent) &&
            headArrContent.map((item, idx) => (
              <div
                className="head-item"
                style={{ ...item.styles }}
                key={idx + item.text}
              >
                {item.text}
              </div>
            ))}
        </div>
        <div className="form-list">
          <Form.List name="executives1">
            {(fields, { add, remove }) => {
              const items = fields.map((_, index) => index.toString());

              return (
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragStart={handleDragStart}
                  onDragEnd={handleDragEnd}
                  modifiers={[restrictToVerticalAxis, restrictToWindowEdges]}
                >
                  <SortableContext
                    items={items}
                    strategy={verticalListSortingStrategy}
                  >
                    {fields.length > 0 ? (
                      fields.map((field, idx) => (
                        <SortableItem
                          key={field.key}
                          bodyContentList={bodyContentList}
                          form={form}
                          index={idx}
                          field={field}
                          remove={remove}
                          type={type}
                          propsAnimation={isAnimation}
                        />
                      ))
                    ) : (
                      <div className="no-data">No Data</div>
                    )}
                  </SortableContext>
                  <div className="adding-row">
                    <div
                      onClick={async () => {
                        setIsAnimation(true);
                        await add({ shouldDisplay: true });
                        const obj = form.getFieldsValue();
                        saveKeyContactsData({
                          ...keyContactsData,
                          buyer: deleteMarkFromKeyName(obj, '1'),
                        });
                      }}
                    >
                      <span className="appkiticon icon-circle-plus-fill" />
                      Add New Executive
                    </div>
                  </div>
                </DndContext>
              );
            }}
          </Form.List>
        </div>
      </Form>
    </div>
  );
};

const mapStateToProps = ({ analysis }) => ({
  keyContactsData: analysis.keyContactsData,
});

const mapDispatchToProps = (dispatch) => ({
  setShowKeyContacts(bool) {
    dispatch(action.setShowKeyContacts(bool));
  },
  saveKeyContactsData(data) {
    dispatch(action.saveKeyContactsData(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(KeyExecutive));
